<template>
  <right-panel title="Фильтр" :open="isOpen" @close="closeFilter">
    <a-form @submit.prevent method="get">
      <template v-if="filterTypes">
        <right-panel-title>Тип запроса</right-panel-title>
        <div>
          <a-form-item
            v-for="filterType in filterTypes"
            :key="`filter-type-` + filterType.value"
            class="checkbox-item"
          >
            <a-checkbox v-model:checked="filterType.checked">
              {{ filterType.label }}
            </a-checkbox>
          </a-form-item>
        </div>
        <hr class="mt-40 mb-40" />
      </template>
      <template v-if="filterRequestStatuses.length > 0">
        <right-panel-title>Статус запроса</right-panel-title>
        <div>
          <a-form-item
            v-for="filterRequestStatus in filterRequestStatuses"
            :key="`filter-request-status-` + filterRequestStatus.value"
            class="checkbox-item"
          >
            <a-checkbox v-model:checked="filterRequestStatus.checked">
              {{ filterRequestStatus.label }}
            </a-checkbox>
          </a-form-item>
        </div>
        <hr class="mt-40 mb-40" />
      </template>
      <right-panel-buttons>
        <button-default @click="resetFilter"> Очистить </button-default>
        <button-primary @click="applyFilter"> Применить </button-primary>
      </right-panel-buttons>
    </a-form>
  </right-panel>
</template>

<script setup>
  import RightPanel from '@/views/portal/components/panels/RightPanel.vue';
  import RightPanelTitle from '@/views/portal/components/panels/RightPanelTitle.vue';
  import ButtonPrimary from '@/views/portal/components/UI/ButtonPrimary.vue';
  import ButtonDefault from '@/views/portal/components/UI/ButtonDefault.vue';
  import RightPanelButtons from '@/views/portal/components/panels/RightPanelButtons.vue';

  const props = defineProps({
    isOpen: Boolean,
    filterTypes: Array,
    filterRequestStatuses: {
      type: Array,
      default: () => [],
    },
    filterTags: Array,
  });

  const emit = defineEmits([
    'close',
    'update:filter',
    'resetFilter',
    'applyFilter',
  ]);

  const applyFilter = () =>
    emit('update:filter', {
      types: props.filterTypes,
      requestStatuses: props.filterRequestStatuses,
    });
  const closeFilter = () => emit('close');
  const resetFilter = () => emit('resetFilter');
</script>

<style scoped lang="scss">
  .checkbox-item {
    margin-bottom: 0;
  }
</style>
